import {UtilitiesService} from "../services/utilities.service";
import {Subscription} from "rxjs";
import {Directive} from "@angular/core";

@Directive()
export class SubscriptionBase {

  constructor(private _componentName: string) {
  }

  protected subscriptions: Subscription[] = [];

  public get uuid(): string {
    return this._uuid;
  }

  private _uuid: string = UtilitiesService.newUuid();

  public get componentName(): string {
    return this._componentName;
  }

  public set componentName(componentName: string) {
    this._componentName = componentName;
  }

  public cleanup(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
